import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

import {Table} from 'spectra-logic-ui/components';
import {dateTimeLong} from 'spectra-logic-ui/helpers/date';

import {LifecycleV2, Destination} from '@/types';
import {Dispatch, Store} from 'spectra-logic-ui';
import {fetchResource} from 'spectra-logic-ui/actions';
import {connect} from 'react-redux';

type Props = {
  lifecycle: LifecycleV2;
  destinations: Destination[];
  fetching: boolean;
  error: boolean;
  fetchDestinations: () => Promise<any>;
}

const useStyles = makeStyles({
  tableRow: {
    '& > *': {
      overflowWrap: 'break-word',
    },
  },
});

const PropertiesDetails = ({lifecycle, destinations, fetchDestinations}: Props) => {
  const classes = useStyles();

  React.useEffect(() => {
    if (fetchDestinations !== undefined) {
      fetchDestinations();
    }
  }, []);

  let restoreTo = null as any;
  if (lifecycle && lifecycle.restoreTo && lifecycle.restoreTo.length !== 0) {
    restoreTo = lifecycle.restoreTo.map((storage: string) => {
      const foundDest = destinations.find((dest) => dest.id == storage);
      return foundDest ? foundDest.name + ' ('+ foundDest.id +')' : null;
    });
  }
  return (
    <Table>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Description</Table.Cell>
          <Table.Cell>{lifecycle.description}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Upload Expiration</Table.Cell>
          <Table.Cell>{lifecycle.uploads}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Marker Expiration</Table.Cell>
          <Table.Cell>{lifecycle.markers ? 'Enabled' : 'Disabled'}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Restore To</Table.Cell>
          <Table.Cell>{restoreTo ? restoreTo.join(', ') : 'Use Default'}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Force Initial Copy</Table.Cell>
          <Table.Cell>{lifecycle.afterPut ? 'Enabled' : 'Disabled'}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Ignore Storage Class</Table.Cell>
          <Table.Cell>{lifecycle.ignoreClass ? 'Enabled' : 'Disabled'}</Table.Cell>
        </Table.Row>
        {lifecycle.useWith && lifecycle.useWith.length > 0 &&
          <Table.Row>
            <Table.Cell>Use With Buckets</Table.Cell>
            <Table.Cell>{lifecycle.useWith.join(', ')}</Table.Cell>
          </Table.Row>
        }
        <Table.Row className={classes.tableRow}>
          <Table.Cell>Modified</Table.Cell>
          <Table.Cell>{dateTimeLong(lifecycle.modified)}</Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

const mapStateToProps = (state: Store) => {
  const destinations = state.resources.destinations || {};
  return {
    destinations: destinations.data || [],
    error: destinations.error,
    fetching: destinations.fetching,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchDestinations: () => dispatch(fetchResource('destinations')),
});

export default connect(mapStateToProps, mapDispatchToProps)(PropertiesDetails);
